// extracted by mini-css-extract-plugin
export default {"diff-box-negative":"DiffBox_diff-box-negative__qWtur","diff-box-positive":"DiffBox_diff-box-positive__Iw3qY"};